import React from "react"
import Icon from "@kit/design/icon"

export function IconsPreview() {
  return (
    <div className="flex items-center">
      <div className="w-6 h-6 flex items-center justify-center mr-4">
        <Icon name="globe" />
      </div>
      <div>Icons</div>
    </div>
  )
}
